import React, { useState, useEffect } from "react";
import axios from "axios";
// import Navbar from "../NavBar";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CustomNavbar from "../CustomPermissions/CustomNavbar";


import "./sop.css";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const SopModelPage = () => {
  const [sops, setSops] = useState([]);
  const [content, setContent] = useState("");
  const [filteredSops, setFilteredSops] = useState([]);
  const [canEdit, setCanEdit] = useState(false); // Track edit permission from API
  const [newSop, setNewSop] = useState({
    name: "",
    department: "",
    designation: "",
    docs: null,
    ppt_files: [],
    pdf_files: [],
    doc_files: [],
    desc: "",
    users: [],
  });
  const [editingSop, setEditingSop] = useState(null);
  const [filter, setFilter] = useState("");
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [showCreateEditModal, setShowCreateEditModal] = useState(false); // For Create/Edit modal
  const [showViewDescModal, setShowViewDescModal] = useState(false); // For Description modal
  const [currentDesc, setCurrentDesc] = useState(""); // Store current description
  const [users, setUsers] = useState([]); // Store fetched users

  useEffect(() => {
    fetchSops();
    fetchDepartments();
    fetchDesignations();
    fetchUsers();
  }, []);

  const fetchSops = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/SOP/sops/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      // Check if response has new format with can_edit flag, or fallback to old format
      let sopData = response.data;
      let hasEditPermission = false;

      if (response.data && response.data.data) {
        // New format: { data: [...], can_edit: true/false }
        sopData = response.data.data;
        hasEditPermission = response.data.can_edit === true;
      } else if (Array.isArray(response.data) && response.data.length > 0) {
        // Old format: array with can_edit on each item
        sopData = response.data;
        hasEditPermission = response.data[0]?.can_edit === true;
      }

      // Also check if user is superuser
      const isSuperuser = localStorage.getItem("is_superuser") === "true";
      setCanEdit(isSuperuser || hasEditPermission);
      setSops(sopData);
      setFilteredSops(sopData);
    } catch (error) {
      // console.error("Error fetching SOPs:", error);
      setCanEdit(false);
      setSops([]);
      setFilteredSops([]);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/departments/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      setDepartments(response.data);
    } catch (error) {
      // console.error("Error fetching departments:", error);
    }
  };

  const fetchDesignations = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/designations/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      setDesignations(response.data);
    } catch (error) {
      // console.error("Error fetching designations:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const isSuperuser = localStorage.getItem("is_superuser") === "true";
      if (!isSuperuser) return; // Only superusers can access /manage/users/all/

      const accessToken = localStorage.getItem("access_token");
      if (accessToken) {
        const response = await axios.get(
          getApiUrl('/Authentication/manage/users/all/'),
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        setUsers(response.data.users || []);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleInputChange = (field, value) => {
    if (editingSop) {
      setEditingSop({ ...editingSop, [field]: value });
    } else {
      setNewSop({ ...newSop, [field]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Get values based on whether we're editing or creating
    const nameValue = editingSop ? (editingSop.hasOwnProperty('name') ? editingSop.name : editingSop.descs__name) : newSop.name;
    const departmentValue = editingSop ? editingSop.department : newSop.department;
    const designationValue = editingSop ? editingSop.designation : newSop.designation;
    const descValue = editingSop ? editingSop.desc : newSop.desc;
    const usersValue = editingSop ? editingSop.users : newSop.users;

    // Validate: Access require either department, designation OR users
    const hasDepartment = departmentValue && departmentValue !== '' && departmentValue !== 'undefined';
    const hasDesignation = designationValue && designationValue !== '' && designationValue !== 'undefined';
    const hasUsers = usersValue && usersValue.length > 0;

    if (!hasDepartment && !hasDesignation && !hasUsers) {
      alert('Please select either a Department, Designation OR assign to at least one User.');
      return;
    }

    // Validate description
    if (!descValue || descValue.trim() === '' || descValue.toLowerCase() === 'undefined' || descValue === '<p>&nbsp;</p>' || descValue === '<p></p>') {
      alert('Please enter a description before submitting. Description cannot be empty.');
      return;
    }

    const formData = new FormData();
    if (nameValue) formData.append("name", nameValue);
    if (departmentValue) formData.append("department", departmentValue);
    if (designationValue) formData.append("designation", designationValue);

    // Check for newly uploaded files (arrays)
    const pptsToUpload = editingSop ? (editingSop.ppt_files_new || []) : (newSop.ppt_files || []);
    const pdfsToUpload = editingSop ? (editingSop.pdf_files_new || []) : (newSop.pdf_files || []);
    const docsToUpload = editingSop ? (editingSop.doc_files_new || []) : (newSop.doc_files || []);

    if (pptsToUpload && pptsToUpload.length > 0) {
      Array.from(pptsToUpload).forEach(file => formData.append("ppt_files", file));
    }
    if (pdfsToUpload && pdfsToUpload.length > 0) {
      Array.from(pdfsToUpload).forEach(file => formData.append("pdf_files", file));
    }
    if (docsToUpload && docsToUpload.length > 0) {
      Array.from(docsToUpload).forEach(file => formData.append("doc_files", file));
    }
    formData.append("desc", descValue);

    // Append users as a list
    if (usersValue && usersValue.length > 0) {
      usersValue.forEach(userId => {
        formData.append("users", userId);
      });
    }

    try {
      if (editingSop) {
        const response = await axios.put(
          `${API_BASE_URL}/SOP/sops/update/${editingSop.id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.data.status === "updated") {
          alert('SOP updated successfully!');
        }
      } else {
        const response = await axios.post(
          `${API_BASE_URL}/SOP/sops/create/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.status === 201) {
          alert('SOP created successfully!');
        }
      }
      fetchSops();
      closeCreateEditModal();
    } catch (error) {
      console.error("Error saving SOP:", error);

      // Handle backend validation errors
      if (error.response) {
        const errorMessage = error.response.data?.error ||
          error.response.data?.message ||
          'An error occurred while saving the SOP.';
        const errorDetails = error.response.data?.details ?
          `\n\nDetails: ${JSON.stringify(error.response.data.details)}` : '';

        alert(`Error: ${errorMessage}${errorDetails}`);
      } else {
        alert('Unable to connect to the server. Please check your connection and try again.');
      }
    }
  };

  const openCreateEditModal = (sop = null) => {
    if (sop) {
      setEditingSop({ ...sop, name: sop.descs__name || "", users: sop.users || [] }); // Ensure users array exists
    } else {
      setEditingSop(null);
      setNewSop({ name: "", department: "", designation: "", docs: null, ppt_files: [], pdf_files: [], doc_files: [], descs__desc: "", users: [] });
    }
    setShowCreateEditModal(true);
  };

  const closeCreateEditModal = () => {
    setShowCreateEditModal(false);
    setEditingSop(null);
    setNewSop({ name: "", department: "", designation: "", docs: null, ppt_files: [], pdf_files: [], doc_files: [], desc: "", users: [] });
  };

  const handleViewDescription = (desc) => {
    setCurrentDesc(desc); // Set the description to be displayed
    setShowViewDescModal(true); // Open the description modal
  };

  const closeViewDescModal = () => {
    setShowViewDescModal(false); // Close the description modal
    setCurrentDesc(""); // Reset the description
  };

  const deleteSop = async (id) => {
    if (!window.confirm("Are you sure you want to delete this SOP?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/SOP/sops/delete/${id}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      fetchSops();
    } catch (error) {
      // console.error("Error deleting SOP:", error);
    }
  };

  const deleteSopFile = async (fileId) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;

    try {
      await axios.delete(`${API_BASE_URL}/SOP/files/delete/${fileId}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });

      // Update local state to remove the file
      if (editingSop && editingSop.files) {
        const updatedFiles = editingSop.files.filter((f) => f.id !== fileId);
        setEditingSop({
          ...editingSop,
          files: updatedFiles,
        });

        // Also update sops and filteredSops lists to reflect change immediately in background
        const updateList = (list) => list.map(sop => 
          sop.id === editingSop.id ? { ...sop, files: updatedFiles } : sop
        );
        setSops(updateList(sops));
        setFilteredSops(updateList(filteredSops));
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      alert("Failed to delete file.");
    }
  };

  const handleFileChange = (e, type) => {
    const selectedFiles = Array.from(e.target.files);
    if (editingSop) {
      setEditingSop({ ...editingSop, [`${type}_files_new`]: selectedFiles });
    } else {
      setNewSop({ ...newSop, [`${type}_files`]: selectedFiles });
    }
  };

  const filterSops = (e) => {
    setFilter(e.target.value);
    const filtered = sops.filter((sop) =>
      sop.designation_name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredSops(filtered);
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row">
        <CustomNavbar />
        <div
          className="container-fluid"
          style={{ margin: "20px auto", padding: "0 15px" }}
        >
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
            <h2 className="mb-4 text-center text-blue-500">SOP Management</h2>

            <div className="d-flex flex-column flex-md-row align-items-center">
              {/* Add Department Button */}
              <Link
                to="/departmentpage"
                className="text-white bg-blue-800 py-2 px-4 rounded hover:bg-blue-500 mr-2"
              >
                Add Department
              </Link>

              {/* Add Designation Button */}
              <Link
                to="/designationpage"
                className="text-white bg-blue-800  py-2 px-4 rounded hover:bg-blue-500"
              >
                Add Designation
              </Link>

              {canEdit && (
                <>
                  <Link
                    to="/sopmanagement"
                    className="text-white bg-green-600 py-2 px-4 rounded hover:bg-green-500 mr-2"
                  >
                    Manage SOPs
                  </Link>
                  <button
                    className="bg-blue-500 py-2 px-4 rounded ml-2 text-white hover:bg-blue-800 mb-4 mb-md-0"
                    onClick={() => openCreateEditModal()}
                  >
                    Add New SOP
                  </button>
                </>
              )}
            </div>
          </div>



          {/* SOP List */}
          <div className="overflow-x-auto mx-auto w-full">
            <table
              className="text-sm border-separate border-spacing-y-2 bg-white border-gray-300 "
              style={{ width: "100%", minWidth: "90%" }}
            >
              <thead className="table-dark">
                <tr className="bg-blue-500">
                  <th className="py-2 px-4  text-center">#</th>
                  <th className="py-2 px-4 text-center">Designation</th>
                  <th className="py-2 px- text-center">Department</th>
                  <th className="py-2 px-4 text-center">Description</th>
                  <th className="py-2 px-4 text-center">Documents</th>
                  <th className="py-2 px-4 text-center">SOP Name</th>
                </tr>
              </thead>
              <tbody>
                {filteredSops.map((sop, index) => (
                  <tr key={sop.id}>
                    <td className="py-2 px-4 border-b text-center">
                      {index + 1}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {sop.designation__name}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {sop.designation__dept__name}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {sop.descs__name}
                    </td>

                    <td className="py-2 px-4 border-b text-center space-x-2">
                      <div className="flex flex-col space-y-1">
                        {sop.files && sop.files.map((file, idx) => (
                          <a key={idx} href={(API_BASE_URL.replace('/api', '') + file.file_url).replace('//media', '/media')} target="_blank" rel="noreferrer"
                            className={`font-bold text-sm ${file.file_type === 'ppt' ? 'text-orange-500 hover:text-orange-700' : file.file_type === 'pdf' ? 'text-red-500 hover:text-red-700' : 'text-blue-600 hover:text-blue-800'}`}
                            title={`View ${file.file_type.toUpperCase()}`}>
                            {file.file_name}
                          </a>
                        ))}
                      </div>
                    </td>

                    <td className="py-2 px-4 border-b text-center flex justify-center items-center h-full space-x-2">
                      <button
                        className="bg-blue-500 py-2 px-3 text-white rounded mr-2"
                        onClick={() => handleViewDescription(sop.descs__desc)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-eye"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                          <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                        </svg>
                      </button>
                      {/* Only show Edit and Delete buttons if user has edit permission */}
                      {canEdit && (
                        <>
                          <button
                            className="bg-yellow-300 py-2 px-3 text-white rounded mr-2"
                            onClick={() => openCreateEditModal(sop)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pen-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001" />
                            </svg>
                          </button>
                          <button
                            className="bg-red-500 py-2 px-3 text-white rounded mr-2"
                            onClick={() => deleteSop(sop.id)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-trash-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                            </svg>
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Create/Edit Modal */}
          {showCreateEditModal && (
            <div
              className="fixed inset-0 flex justify-center items-center z-50"
              id="marketingmodalopen"
              style={{ width: "100vw", height: "100vh" }}
            >
              {/* <div className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"></div> */}
              <div
                className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
                style={{
                  width: "100vw",
                  height: "150%",
                  background: "black",
                  backgroundSize: "200% 200vh",
                  overflowY: "hidden",
                  paddingBottom: "150px",
                }}
              ></div>
              {/* <div className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg" style={{ marginTop: "100px" }}> */}
              <div
                className="relative bg-white rounded-lg shadow-lg"
                style={{
                  // marginTop: "50px",
                  height: "98vh",
                  width: "98vw", // Set height to allow scrolling
                  overflowY: "auto", // Enable scrolling inside modal
                }}
              >
                <div
                  className="overflow-auto max-h-[90vh]"
                  style={{ padding: "50px 10px 100px 100px", paddingTop: "20px", borderRadius: "10px" }}
                >
                  {/* <div className="modal-content"> */}
                  <div className="modal-header text-white bg-blue-500 rounded">
                    <h5 className="modal-title px-3 py-2 text-white bg-blue-500">
                      {editingSop ? "Update SOP" : "Create New SOP"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white text-white"
                      onClick={closeCreateEditModal}
                    ></button>
                  </div>
                  {/* <div className="modal-body"> */}
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-5">
                        <div className="mb-3">
                          <label className="form-label fw-bold">SOP Name (Optional)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={
                              editingSop
                                ? editingSop.hasOwnProperty('name') ? editingSop.name : (editingSop.descs__name || "")
                                : newSop.name || ""
                            }
                            onChange={(e) => handleInputChange("name", e.target.value)}
                            placeholder="Enter SOP Name"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-bold">Department (Optional)</label>
                          <select
                            name="department"
                            value={
                              editingSop
                                ? editingSop.department || ""
                                : newSop.department || ""
                            }
                            onChange={(e) => handleInputChange("department", e.target.value)}
                            className="form-select"
                          >
                            <option value="">Select Department</option>
                            {departments.map((dept) => (
                              <option key={dept.id} value={dept.id}>
                                {dept.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-bold">Designation (Optional)</label>
                          <select
                            name="designation"
                            value={
                              editingSop
                                ? editingSop.designation || ""
                                : newSop.designation || ""
                            }
                            onChange={(e) => handleInputChange("designation", e.target.value)}
                            className="form-select"
                          >
                            <option value="">Select Designation</option>
                            {designations.map((designation) => (
                              <option key={designation.id} value={designation.id}>
                                {designation.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-bold">Assign to Users (Optional)</label>
                          <div
                            className="border rounded p-2"
                            style={{ maxHeight: "150px", overflowY: "auto" }}
                          >
                            {users.map((user) => (
                              <div key={user.id} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`user-${user.id}`}
                                  value={user.id}
                                  checked={
                                    editingSop
                                      ? (editingSop.users || []).includes(user.id)
                                      : (newSop.users || []).includes(user.id)
                                  }
                                  onChange={(e) => {
                                    const userId = parseInt(e.target.value);
                                    const isChecked = e.target.checked;
                                    const currentUsers = editingSop ? (editingSop.users || []) : (newSop.users || []);
                                    const newUsers = isChecked
                                      ? [...currentUsers, userId]
                                      : currentUsers.filter(id => id !== userId);

                                    handleInputChange("users", newUsers);
                                  }}
                                />
                                <label className="form-check-label" htmlFor={`user-${user.id}`}>
                                  {user.name} ({user.username})
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-bold">Existing Files</label>
                          <div className="border rounded p-3 bg-light">
                            {editingSop && editingSop.files && editingSop.files.length > 0 ? (
                              <ul className="list-group">
                                {editingSop.files.map((file) => (
                                  <li key={file.id} className="list-group-item d-flex justify-content-between align-items-center">
                                    <div>
                                      <span className={`badge bg-${file.file_type === 'pdf' ? 'danger' : file.file_type === 'ppt' ? 'warning' : 'primary'} me-2`}>
                                        {file.file_type.toUpperCase()}
                                      </span>
                                      <a href={`${API_BASE_URL.replace('/api', '')}${file.file_url}`} target="_blank" rel="noopener noreferrer">
                                        {file.file_name}
                                      </a>
                                    </div>
                                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => deleteSopFile(file.id)}>
                                      Delete
                                    </button>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <p className="text-muted mb-0">No files uploaded yet.</p>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 shadow-sm p-3 border rounded bg-light">
                          <label className="form-label fw-bold border-bottom pb-2 w-100">Upload New Documents</label>

                          <div className="mb-3 mt-3">
                            <label className="form-label text-sm fw-semibold text-secondary">PPT (PowerPoint)</label>
                            <input
                              type="file"
                              className="form-control form-control-sm"
                              multiple
                              accept=".ppt,.pptx"
                              onChange={(e) => handleFileChange(e, 'ppt')}
                            />
                          </div>

                          <div className="mb-3">
                            <label className="form-label text-sm fw-semibold text-secondary">PDF</label>
                            <input
                              type="file"
                              className="form-control form-control-sm"
                              multiple
                              accept=".pdf"
                              onChange={(e) => handleFileChange(e, 'pdf')}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label text-sm fw-semibold text-secondary">DOC (Word)</label>
                            <input
                              type="file"
                              className="form-control form-control-sm"
                              multiple
                              accept=".doc,.docx"
                              onChange={(e) => handleFileChange(e, 'doc')}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-7">
                        <div className="mb-3 h-100">
                          <label className="form-label fw-bold">Description</label>
                          <div className="ckeditor-container h-100 pb-4">
                            <CKEditor
                              editor={ClassicEditor}
                              data={editingSop?.descs__desc || newSop.descs__desc || ""}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                handleInputChange("desc", data);
                              }}
                              config={{
                                toolbar: [
                                  "heading",
                                  "|",
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strikethrough",
                                  "link",
                                  "subscript",
                                  "superscript",
                                  "highlight",
                                  "|",
                                  "bulletedList",
                                  "numberedList",
                                  "todoList",
                                  "|",
                                  "alignment",
                                  "indent",
                                  "outdent",
                                  "|",
                                  "blockQuote",
                                  "code",
                                  "codeBlock",
                                  "horizontalLine",
                                  "|",
                                  "insertTable",
                                  "tableColumn",
                                  "tableRow",
                                  "mergeTableCells",
                                  "|",
                                  "removeFormat",
                                  "undo",
                                  "redo",
                                ],
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        onClick={closeCreateEditModal}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                  {/* </div> */}
                  {/* </div> */}
                </div>
              </div>
            </div>
          )}

          {/* View Description Modal */}
          {showViewDescModal && (
            <div
              className="fixed inset-0 flex justify-center items-center z-50"
              id="marketingmodalopen"
              style={{ width: "100vw", height: "100vh" }}
            >
              {/* <div className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"></div> */}
              <div
                className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
                style={{
                  width: "100vw",
                  height: "150%",
                  background: "black",
                  backgroundSize: "200% 200vh",
                  overflowY: "hidden",
                  paddingBottom: "150px",
                }}
              ></div>
              {/* <div className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg" style={{ marginTop: "100px" }}> */}
              <div
                className="relative bg-white rounded-lg shadow-lg"
                style={{
                  // marginTop: "50px",
                  height: "98%", // Set height to allow scrolling
                  overflowY: "auto", // Enable scrolling inside modal
                  margin: "10px ",

                }}
              >
                <div
                  className="overflow-auto max-h-[80vh]"
                  style={{
                    padding: "10px 10px 100px 100px",
                    paddingTop: "20px",
                    border: "1px solid gray",
                  }}
                >
                  <h2 className="text-center text-blue-700 mb-2">Add File</h2>
                  <button
                    type="button"
                    onClick={closeViewDescModal}
                    className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-red-700 transition-colors"
                    style={{ position: "absolute", top: "20px", right: "20px" }}
                  >
                    X
                  </button>
                  <div className="modal-body border p-2">
                    <div
                      dangerouslySetInnerHTML={{ __html: currentDesc }}
                    ></div>
                  </div>
                  <div className="modal-footer mt-3">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={closeViewDescModal}
                    >
                      Close
                    </button>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SopModelPage;